import React, { useState } from 'react';  
import styled from 'styled-components';
export default function CommentForm({content, onChange}) { 
  return (
    <FormWrapper >
      <FormInputWrapper>
        <FormInput
          value={content}
          onChange={(e)=>{
            if(onChange)onChange(e.target.value)
          }}
        />
      </FormInputWrapper>
    </FormWrapper>
  );
}

const FormWrapper = styled.div`
  height: 100%;
  flex: 1 1 auto;
`;
const FormInputWrapper = styled.div`
  padding : 0 calc(100vw*(17/375));
  height: calc(100vw*(136/375));
`
const FormInput = styled.textarea` 
  border: 1px solid #C4C4C4;
  border-radius: calc(100vw*(9/375));
  width : 100%;
  height: 100%;
  padding: calc(100vw*(9/375)) calc(100vw*(10/375));
  //font
  font-style: normal;
  font-weight: normal;
  font-size: calc(100vw*(14/375));
  color: #121212;
`;
